import React from 'react';

function Gallery() {
  const projects = [
    { image: './Images/IMG030.png' ,
      title: 'Realistic home design',
  },
  { image: './Images/IMG031.png' ,
  title: 'Realistic home design',
},
{ image: './Images/IMG032.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG033.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG029.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG028.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG027.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG026.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG025.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG024.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG023.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG022.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG021.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG020.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG029.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG018.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG013.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG016.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG015.png' ,
title: 'Realistic home design',
},
{ image: './Images/IMG014.png' ,
title: 'Realistic home design',
}
  ];

  return (
    <section id="projects" className="py-16 bg-gray-100">
      <div className="container mx-auto text-center px-4">
        <h2 className="text-3xl font-bold mb-8 inline-block border-4 bg-blue-600 border-blue-700 rounded-lg p-2">Gallery</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div key={index} className="bg-white p-4">
              <h3 className="text-xl font-semibold">{project.title}</h3>
              <img src={project.image} alt={project.title} className="w-full h-48 object-cover" />
        
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Gallery;
